import { Anomaly } from '../models/Anomalies';
import { FormCategory, FormIn } from '../models/Forms';
import { Print, PrintTypeUI } from '../models/Prints';
import { BaseProcess, ProcessFilter, ProcessHistory, ProcessIn, ProcessTypeIn, Status, QueueResult, ProcessType } from '../models/Processes';
import { Farm } from '@abaco/farm-registry/src/modules/farm-registry/models/Farm';
import SSOModule from '@abaco/sso-web-module/src/abaco-module';
import { HTTPClient, propsToDate, propsToDatePaged } from '@abaco/web-common/src/HTTP';
import { PagedResults, PagingParams } from '@abaco/web-common/src/Paging';

export default class PrintApi {

    private http: HTTPClient;
    private rootPath: string;

    constructor(http: HTTPClient, rootPath: string) {
        this.http = http;
        this.rootPath = rootPath
    }

    async insertPrint(processId: number, printTypeId: string): Promise<string> {
        const res = await this.http.post(`/sitiagri-rest-api/api_basic/v1/applications/applications/${processId}/prints/${printTypeId}`);
        return res.data;
    }

    async getProcessPrints(processId: number): Promise<PagedResults<PrintTypeUI>> {
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/applications/applications/${processId}/dictionary_prints`);
        return res.data;
        // let res: PrintTypeUI[] = [];
        // let el: PrintTypeUI = {
        //     app_type_id: 123,
        //     fg_active: 1,
        //     fg_main_print: 1,
        //     in_queue: 0,
        //     output_type: "PDF",
        //     parameters: [],
        //     print_name: "Cs agreement document",
        //     print_type_id: "asd",
        //     sco_output_type: "PDF",
        // };
        // res.push(el);
        // el = {
        //     app_type_id: 123,
        //     fg_active: 1,
        //     fg_main_print: 1,
        //     in_queue: 0,
        //     output_type: "PDF",
        //     parameters: [],
        //     print_name: "Application documentation",
        //     print_type_id: "asd",
        //     sco_output_type: "PDF",
        // };
        // res.push(el);
        // el = {
        //     app_type_id: 123,
        //     fg_active: 1,
        //     fg_main_print: 1,
        //     in_queue: 0,
        //     output_type: "PDF",
        //     parameters: [],
        //     print_name: "Forms applied",
        //     print_type_id: "asd",
        //     sco_output_type: "PDF",
        // };
        // res.push(el);
        // return {totalcount: 3, offset: 0, records: res, count: 3};
    }

}
